export const dynamicTable = {
	questionnaireSelect: {
		select: '.js-dynamic-table-select-questionnaire',
	},
	paginatorSelect: {
		select: '.js-dynamic-table-select-pagination',
	},
	showMoreSelect: {
		select: '.js-dynamic-table-select-showMore',
	},
	questionSettings: {
		type: '.js-dynamic-table-type',
		setting: '.js-dynamic-table-settings',
		settingContainer: '.js-dynamic-table-settings-container',
		container: '.js-dynamic-table-columns-container',
		imageSubsettings: '.js-dynamic-table-settings-image',
	},
}
